import { Suspense } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import * as Sentry from '@sentry/react';
import { SearchRoomSkeleton } from '~/components/common/Skeleton';
import CharacterListResults from './CharacterListResults';
import GroupListResults from './GroupListResults';

interface SearchResultsProps {
  query: string;
}

export default function SearchResults({ query }: SearchResultsProps) {
  if (query === '') {
    return null;
  }
  return (
    <>
      <Suspense fallback={<SearchRoomSkeleton />}>
        <Sentry.ErrorBoundary fallback={undefined}>
          <CharacterListResults query={query} />
        </Sentry.ErrorBoundary>

        <Sentry.ErrorBoundary fallback={undefined}>
          <GroupListResults query={query} />
        </Sentry.ErrorBoundary>
      </Suspense>
    </>
  );
}

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.title.section18_medium};
  `}
`;
export const SubLength = styled.p`
  ${({ theme }) => css`
    color: ${theme.content.content_light_3};
    ${theme.fontStyle.text.body14_medium};
  `}
`;
